import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-providers-faq',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './providers-faq.component.html',
  styleUrl: './providers-faq.component.scss'
})
export class ProvidersFaqComponent {
  faqs = [
    {
      q:"Why can’t my provider just give me a reduced rate without joining FHAdvantage?",
      a:"In many states, legal issues prevent providers from lowering their rates. FHAdvantage, allows them to offer their fees at a discounted rate."
    },
    {
      q:"How much of a discount will me and my family receive?",
      a:"Discounts vary by provider, but typically patients can recoup their FHAdvantage annual fee on the first visit."
    },
    {
      q:"Can I join if I have insurance?",
      a:"Of course, however, it may only be used for services that are not being covered by insurance or Medicare."
    },
    {
      q:"What if my insurance covers part of the services?",
      a:"Patients are free to use their insurance benefits until they are exhausted and then use FHAdvantage for the remainder of year."
    },
    {
      q:"Is there a limit to the number of services my family can receive?",
      a:"FHAdvantage is unlimited coverage for the entire family if your provider is in our network."
    },
    {
      q:"Can I pay for my membership with my FSA or HSA card?",
      a:"No, typically, FHAdvantage discounts are declined by FSA/HSA. We ask that you use regular credit or debit cards for annual memberships."
    },
    {
      q:"Where can I get a replacement membership card?",
      a:"FHAdvantage is completely digital. Instructions on how to download membership cards can be found when you log into the patient portal. If you don’t have your card, providers can also look in the Provider Portal for active members."
    },
    {
      q:"Why aren’t my family members listed on my digital card?",
      a:"Dependent information can be seen by patients and providers once logging into FHAdvantage."
    },
    {
      q:"Does my membership automatically renew?",
      a:"Yes, memberships will automatically renew on the date of purchase. Patients will need to cancel their membership inside the Patient Portal."
    },
    {
      q:"What if my provider is not listed in the Provider Directory?",
      a:"If your provider is not listed in the directory, click here to submit the provider’s information and FHAdvantage will reach out to them about joining the network."
    }
  ];
}
